define('view-model',['require','knockout','store','helpers','knockout-mapping','entity','task','layout','course','trainingVM','quiz-game','user','training','pubsub','page-component','course-componentVM','component-hotspots','leaderboard','modular-navigation','component-answer-popup','navigationVM','custom'],function(require) {
	'use strict';

	var ko = require('knockout'),
        store = require('store').default,
        helpers     = require('helpers'),
        mapping     = require('knockout-mapping'),
        EntityVM    = require('entity'),
        TaskVM      = require('task'),
        LayoutVM    = require('layout'),
        CourseVM    = require('course'),
        TrainingVM  = require('trainingVM'),
        QuizGameVM  = require('quiz-game'),
        UserVM      = require('user'),

        Training = require('training'),

        PubSub = require('pubsub'),
        PageComponentVM = require('page-component'),
        CourseComponentVM = require('course-componentVM'),
        Hotspots    = require('component-hotspots'),
        Leaderboard = require('leaderboard'),
        ModularNavigation    = require('modular-navigation'),
        AnswerPopup = require('component-answer-popup'),

        NavigationVM  = require('navigationVM'),
        CustomJS    = require('custom'),

        content = document.getElementById('js-layout-content'),

		ViewModel = function(dataContext) {
            this.entity = new EntityVM(this, dataContext);

            this.user = new UserVM(this, dataContext.learning);

            this.layout = new LayoutVM(this, dataContext);

            this.course = new CourseVM(this, dataContext);

            this.training = new TrainingVM(this, dataContext);

            this.task = new TaskVM(this, dataContext);

            this.pageComponent = new PageComponentVM(this, dataContext);

            this.courseComponent = new CourseComponentVM(this, dataContext);

            this.hotspots = new Hotspots(this, dataContext);

            this.leaderboard = new Leaderboard(this, dataContext);

            this.answerPopup = new AnswerPopup(this, dataContext);         // MR

            this.quizGame = new QuizGameVM(this, dataContext);

            this.modularNavigation = new ModularNavigation(this, dataContext);

            this.navigation = new NavigationVM(this, dataContext);

            this.custom = new CustomJS(this, dataContext, ko);

            this.updateVM = function(ID, entity) {
                var cloned,
                    entityID = this.entity.ID(),
                    reload = (!entity && ID === entityID),
                    training = new Training();

                ID = ID || dataContext.learning.current.contentEntityId;

                entity = entity || helpers.content.getEntity(ID, dataContext.learning.training.contentEntities);

                if (entity) {
                    cloned = helpers.content.cloneEntity(entity);

                    if (!cloned || !content) {
                        return;
                    }

                    if (!reload) {

                        store.dispatch({
                            type: 'SET_ENTITY',
                            payload: {
                                ID: ID
                            }
                            // entity: entity
                        });

                        PubSub.publish('page-load-init', {
                            entity: cloned,
                            state: training.state
                        });
                    }

                    if (ID === entityID && !reload) {
                        this.entity.ID.valueHasMutated();
                    } else {
                        mapping.fromJS(cloned, null, this.entity);
                    }

                    if (reload) {
                        return;
                    }

                    this.leaderboard.pageChanged();
                    this.modularNavigation.pageChanged();
                    this.answerPopup.pageChanged();

                    location.hash = ID;
                }
			};
		};

        PubSub.subscribe('page-load-init', function() {
            for (var i = 0; i < content.childNodes.length; i++) {
                ko.cleanNode(content.childNodes[i]);
            }
        });

	return ViewModel;

});

